import { getAccount as wagmiGetAccount } from '@lair-finance/wagmi/core'
import { wagmiConfig } from '@/app/providers/wagmi'

export const getAccount = () => wagmiGetAccount(wagmiConfig)
